jQuery(document).ready(() => {
  const menuController = Router.getController('customer.account.menuController');
  menuController.setRedirect(true);

  $('.content').addClass('in');

  $('.select-month').select2({
    placeholder: __('Select Month'),
    minimumResultsForSearch: Infinity
  });
  $('.select-year').select2({
    placeholder: __('Select Year'),
    minimumResultsForSearch: Infinity
  });
  $('#account-type').select2({
    placeholder: __('Select Account Type'),
    minimumResultsForSearch: Infinity
  });

  checkPaymentType($('input[name="payCheckbox"]:checked').val());

  $('#submit-master').click(() => {
    bootbox.confirm({
      title: __('Master recording bundle confirmation'),
      message: __('Are you sure to add master recording bundle to your license?'),
      buttons: {
        confirm: {
          label: __('Yes'),
          className: 'btn-purple'
        },
        cancel: {
          label: __('No'),
          className: 'btn-light-purple'
        }
      },
      callback(result) {
        if (result) {
          $('#submit-master').button('loading');

          const invoice = $('#submit-master').data('id-invoice');

          $.post(addMasterUrl, {
              invoice
          }, (data, b) => {
            if (data.isError == 1) {
              $('#submit-master').button('reset');

              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(__('License has been successfully upgraded to Master recording bundle'), __('Success'));

              location.reload();
            }
          });
        }
      }
    });
  });

  $('#payVisa, #payACH').on('click', function () {
    checkPaymentType($(this).val());
  });

  $('#payment #submit').click(function () {
    const form = $('form#payment');
    const data = form.serializeJson(true);
    data.invoice = idInvoice;

    form.loading();
    $.post(urlPayInvoice, data).done((data) => {
      toastr.success(__('Payment successful'));
      location.reload();
    }).always(() => {
      form.loading('reset');
    });

    return false;
  });

  function checkPaymentType(value) {
    if (value == 'payVisa') {
      $('#payment').addClass('visible');
      $('#achpayment').removeClass('visible');
      $('#payment').css('display', 'block');
      $('#achpayment').css('display', 'none');
    } else {
      $('#payment').removeClass('visible');
      $('#achpayment').addClass('visible');
      $('#payment').css('display', 'none');
      $('#achpayment').css('display', 'block');
    }
  }
});
